import { IBlogAuthor } from '@tebuto/api/blog/tebutoClient'
import Link from 'next/link'

export function AuthorLabel({ author }: { author: IBlogAuthor | null }) {
    if (!author) {
        return <span>Tebuto</span>
    }

    if (author.url) {
        return (
            <Link href={author.url} className="underline">
                {author.name}
            </Link>
        )
    }

    return <span>{author.name}</span>
}
